import React, { useState, useEffect, useRef } from 'react'
import styles from './index.module.css'
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

const Index = ({setIsOpenDecr, setRequest, request, isOpenDecr}) => {

    const [layoutName, setLayoutName] = useState("default");
    const [cursorPos, setCursorPos] = useState(0);
    const keyboardRef = useRef(null);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';

        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        };
    }, []);

    const layouts = {
        default: [
            "1 2 3 4 5 6 7 8 9 0",
            "й ц у к е н г ш щ з х ъ",
            "ф ы в а п р о л д ж э",
            "я ч с м и т ь б ю .",
            "{lock} {space} {backspace}"
        ],
        shift: [
            "1 2 3 4 5 6 7 8 9 0",
            "Й Ц У К Е Н Г Ш Щ З Х Ъ",
            "Ф Ы В А П Р О Л Д Ж Э",
            "Я Ч С М И Т Ь Б Ю .",
            "{lock} {space} {backspace}"
        ]
    };

    const display = {
        '{backspace}': '⌫',
        '{space}': 'Пробел',
        '{lock}': 'caps'
    };

    const buttonTheme = [
        { class: "hg-space", buttons: "{space}" }
    ];

    const getValue = () => request.find(item => item.id === isOpenDecr)?.decr || "";

    const handleSetDecr = (decr) => {
        const newItem = request.map(item_ => item_.id === isOpenDecr ? {...item_, decr} : item_);
        setRequest(newItem);
    };

    const insertAtCursor = (char) => {
        const current = getValue();
        const newVal = current.slice(0, cursorPos) + char + current.slice(cursorPos);
        handleSetDecr(newVal);
        const newPos = cursorPos + char.length;
        setCursorPos(newPos);
        if (keyboardRef.current) keyboardRef.current.setInput(newVal);
    };

    const onChange = () => {};

    const onKeyPress = (button) => {
        if (button === "{shift}" || button === "{lock}") { handleShift(); return; }
        if (button === "{backspace}") { handleBackspace(); return; }
        if (button === "{space}") { insertAtCursor(" "); return; }
        insertAtCursor(button);
    };

    const handleBackspace = () => {
        if (cursorPos === 0) return;
        const current = getValue();
        const newVal = current.slice(0, cursorPos - 1) + current.slice(cursorPos);
        handleSetDecr(newVal);
        setCursorPos(p => p - 1);
        if (keyboardRef.current) keyboardRef.current.setInput(newVal);
    };

    const handleShift = () => {
        setLayoutName(prev => prev === "default" ? "shift" : "default");
    };

    // Определяем позицию курсора по клику на div с текстом
    const handleDisplayClick = (e) => {
        const el = e.currentTarget;
        const current = getValue();
        let charIndex = current.length;

        const range = document.caretRangeFromPoint
            ? document.caretRangeFromPoint(e.clientX, e.clientY)
            : document.caretPositionFromPoint
                ? (() => { const p = document.caretPositionFromPoint(e.clientX, e.clientY); return p ? { startContainer: p.offsetNode, startOffset: p.offset } : null; })()
                : null;

        if (range && range.startContainer.nodeType === Node.TEXT_NODE) {
            const spanEl = range.startContainer.parentElement;
            const spans = Array.from(el.querySelectorAll('span'));
            const idx = spans.indexOf(spanEl);
            if (idx === 0) charIndex = range.startOffset;
            else if (idx === 2) charIndex = cursorPos + range.startOffset;
        }

        setCursorPos(Math.min(charIndex, current.length));
    };

  return (
    <div className={styles.wrapper_bg}>
        <div className={styles.wrapper}>
            <div className={styles.title}>Комментарий для блюда <br/> "{request.find(item => item.id === isOpenDecr)?.title_ru}"</div>

            <div
                className={styles.text}
                onClick={handleDisplayClick}
                onTouchEnd={handleDisplayClick}
            >
                <span>{getValue().slice(0, cursorPos)}</span>
                <span className={styles.cursor} />
                <span>{getValue().slice(cursorPos)}</span>
            </div>

            <Keyboard
                keyboardRef={r => (keyboardRef.current = r)}
                className={styles.keyboard}
                layout={layouts}
                layoutName={layoutName}
                onChange={onChange}
                onKeyPress={onKeyPress}
                display={display}
                buttonTheme={buttonTheme}
            />

            <div className={styles.buttons}>
                <div className={styles.ok} onClick={() => setIsOpenDecr(null)}>OK</div>
            </div>
        </div>
    </div>
  )
}

export default Index
